export function request(id, accountId, legs) {
    return {
        type: 'BETS_CALCULATE_PAYOUT_REQUEST',
        accountId,
        legs,
        id
    };
}

export function error(id, errors) {
    return {
        type: 'BETS_CALCULATE_PAYOUT_ERROR',
        errors,
        id
    };
}

export function finish(id, payout) {
    return {
        type: 'BETS_CALCULATE_PAYOUT_FINISH',
        payout,
        id
    };
}
